import {
  Database,
  Filter,
  LayoutDashboard,
  FileSpreadsheet,
  Download,
  BarChart3,
  Users,
  CalendarDays,
  Building2,
  LineChart,
  SlidersHorizontal,
  History,
  Sparkles,
} from "lucide-react";
import FeaturePageLayout from "./FeaturePageLayout";
import reportsHeroImg from "../../assets/images/features/Reports-Analytics-hero.png.png";

const workflowSteps = [
  {
    id: 1,
    title: "Unified Data Hub",
    desc: "Brixigo aggregates payroll, attendance, leave and employee data across your organisation in one system.",
    icon: Database,
  },
  {
    id: 2,
    title: "Filter & Segment",
    desc: "Slice reports by employee, department, designation, location or payroll period for precise analysis.",
    icon: Filter,
  },
  {
    id: 3,
    title: "Dashboard Insights",
    desc: "The payroll dashboard surfaces KPIs — headcount, gross pay, deductions and open compliance items at a glance.",
    icon: LayoutDashboard,
  },
  {
    id: 4,
    title: "Generate Reports",
    desc: "Run payroll registers, attendance summaries, leave utilisation and department-wise reports on demand.",
    icon: FileSpreadsheet,
  },
  {
    id: 5,
    title: "Export & Archive",
    desc: "Download reports for management review and audits. Historical data stays secure for trend analysis.",
    icon: Download,
  },
];

const keyBenefits = [
  { title: "Payroll reports", desc: "Salary registers, cost summaries and run-wise breakdowns.", icon: BarChart3 },
  { title: "Attendance reports", desc: "Daily, monthly and exception reports from workforce data.", icon: CalendarDays },
  { title: "Leave reports", desc: "Balances, utilisation and approval trends by team or period.", icon: Users },
  { title: "Department reports", desc: "Headcount and cost views grouped by department or location.", icon: Building2 },
  { title: "Employee reports", desc: "Individual summaries for HR reviews and employee queries.", icon: Users },
  { title: "Dashboard insights", desc: "Live metrics on the Brixigo payroll dashboard for admins and HR.", icon: LayoutDashboard },
  { title: "Data filtering", desc: "Flexible filters so you see exactly the slice you need.", icon: SlidersHorizontal },
  { title: "Exportable reports", desc: "Download outputs for finance, auditors and leadership.", icon: Download },
];

const whatsIncluded = [
  { title: "Payroll Register", desc: "Full run detail with earnings and deductions per employee.", icon: FileSpreadsheet },
  { title: "Attendance Analytics", desc: "Present, absent, late and overtime trends over time.", icon: LineChart },
  { title: "Leave Utilisation", desc: "Policy-wise consumption and balance snapshots.", icon: CalendarDays },
  { title: "Department Cost View", desc: "Salary expense roll-ups by department or cost centre.", icon: Building2 },
  { title: "Executive Dashboard", desc: "Org-wide KPIs without switching between modules.", icon: LayoutDashboard },
  { title: "Period Comparison", desc: "Month-on-month payroll and workforce trends.", icon: BarChart3 },
  { title: "Secure History", desc: "Past runs and reports retained for future analysis.", icon: History },
  { title: "Role-Based Reports", desc: "Admins and HR see org data; managers see team scope.", icon: Filter },
];

export default function ReportsAnalytics() {
  return (
    <FeaturePageLayout
      featureName="Reports & Analytics"
      title="Reports & Analytics"
      subtitle="Turn payroll, attendance and leave data into decisions — with filters, dashboards and exports."
      description="Reports & Analytics provide valuable insights into payroll, attendance, employee performance and organisational operations. Brixigo helps HR and management monitor salary expenses, attendance trends and leave utilisation through visual reports and exportable data."
      heroImage={reportsHeroImg}
      heroImageAlt="Reports and analytics illustration"
      workflowHeading="How Reports & Analytics Works in Brixigo"
      workflowSteps={workflowSteps}
      benefits={keyBenefits}
      included={whatsIncluded}
      ctaIcon={Sparkles}
      ctaTitle="See the Full Picture. Act with Data."
      ctaDescription="From dashboard KPIs to downloadable registers — get the reports your leadership and auditors need."
      ctaButtonLabel="Book a Demo"
    />
  );
}
